import {EventEmitter, Injectable} from '@angular/core';
import {CookieService} from "ngx-cookie-service";
import {Subject} from "rxjs/Subject";
import { Buffer } from 'buffer';
import {NzModalService} from "ng-zorro-antd";

@Injectable()
export class GlobalService {

  // 控制头部和底部是否显示
  public isIndex = false;

  // 是否已登录
  public isLoginedUser = false;

  // 是否显示头部
  public showHeader = true;

  // 是否显示底部
  public showFooter = true;

  // 是否是首次访问
  public isFirstAccess = '0';

  // 用户类型
  public userType: string;

  // 用户是否进行修改了密码操作，0未修改，1修改
  public modifyPwd = '0';

  // token是否需要重新生成的标识
  public tokenChanged = new Subject<any>();

  constructor(private cookie: CookieService, private showModal: NzModalService) { }


  /**
   * session 保存用户信息
   * @param userId
   * @param userName
   */
  saveGDUserInfo(userId, userName) {
    sessionStorage.setItem('gd_userId', userId);
    sessionStorage.setItem('gd_userName', userName);
  }

  removeGDUserInfo() {
    sessionStorage.removeItem('gd_userId');
    sessionStorage.removeItem('gd_userName');
  }

  goLogin() {
    this.removeGDUserInfo();
    this.showModal.error({content: '账号未登录或已失效，请先登录账号！', okText: '确认'});
    // this.showModal.error({content: '账号未登录或已失效，请先' +
    //   '<a href="http://210.76.68.15:7171/login.jspx" target="_blank" class="blue1 bold">登录账号</a>！', okText: '确认'});
    // this.msg.error("请先登录账号");
    // window.open('http://www.gdintegrity.com/login.jspx');
    // window.location.href = 'http://www.gdintegrity.com/login.jspx';
    return false;
  }

  /**
   * 设置登录状态
   * @param isLogin
   */
  setLoginState(isLogin) {
    localStorage.setItem("isLogin", isLogin);
  }

  /**
   * 存储用户基本信息
   * @param isLogin
   */
  setUserInfo(user) {
    localStorage.setItem("_user", user);
    //localStorage.setItem("_user", this.base64encoder(user));
  }

  base64encoder(Context):any{
    let encoder = new Buffer(Context).toString('base64');
    return encoder;
  }

  base64decoder(Context):any{
    let decoder = new Buffer(Context,'base64').toString();
    return decoder;
  }

  deleteLocalStorage() {
    localStorage.clear();
  }

  /**
   * 根据key获取用户对应信息
   * @param key
   * @returns {any}
   */
  getUserInfo(key?): any {
    if (localStorage.getItem("_user") != null) {
      //let userInfo = JSON.parse(this.base64decoder(localStorage.getItem("_user")));
      let userInfo = JSON.parse(localStorage.getItem("_user"));
      if (userInfo) {
        if (key) {
          return userInfo[key];
        } else {
          return userInfo;
        }
      } else {
        return "";
      }
    } else {
      return "";
    }
  }

  /**
   * 获取登录状态
   */
  checkLoginState() {
    this.isLoginedUser = localStorage.getItem("isLogin") == "true" ? true : false;
  }

  uuid() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
  }

  setKey(key, value) {
    this.cookie.set(key, value);
  }

  getValue(key): any {
    return this.cookie.get(key);
  }


  // 用于控制登录成功后返回的页面事件的发射和订阅
  public loginToUrl:EventEmitter<any> = new EventEmitter<any>();

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/global.service.ts